<div class="notification-message-box {{type}}">
  <p>
    <span>{{message}}</span>
  </p>
</div>
